var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    fillRule: "evenodd",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m13.691 15.105 6.102 6.102a.999.999 0 1 0 1.414-1.414l-6.101-6.102A6.972 6.972 0 0 0 16.5 9.499c0-3.863-3.136-7-7-7-3.863 0-7 3.137-7 7 0 3.864 3.137 7 7 7a6.965 6.965 0 0 0 4.191-1.394zM9.5 4.499c2.76 0 5 2.241 5 5 0 2.76-2.24 5-5 5-2.759 0-5-2.24-5-5 0-2.759 2.241-5 5-5z",
    fill: "#515050",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.16581ba14a4a78fd19a5c4165c44ccfe.svg";
export { ForwardRef as ReactComponent };